/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */

import React, { PropsWithChildren } from 'react';
import DefaultErrorFallback from '../DefaultErrorBoundaryFallback';

export interface FallbackProps {
  showErrorMessage?: boolean;
  error: Error | null;
  resetErrorBoundary: (...args: Array<unknown>) => void;
}

const initialState = { error: null, hasError: false };

class CustomErrorBoundary extends React.Component<PropsWithChildren<any>> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: any) {
    return {
      hasError: true,
      error,
    };
  }

  resetErrorBoundary = (...args: Array<unknown>) => {
    this.props.onReset?.(...args);
    this.reset();
  };

  reset() {
    this.setState(initialState);
  }

  render() {
    // @ts-ignore
    const { error } = this.state;

    const { FallbackComponent, fallback, showErrorMessage } = this.props;
    // @ts-ignore
    if (this.state.hasError) {
      const props = {
        error,
        showErrorMessage,
        resetErrorBoundary: this.resetErrorBoundary,
      };

      if (React.isValidElement(fallback)) {
        return fallback;
      }

      if (FallbackComponent) {
        return <FallbackComponent {...props} />;
      }

      // default error fallback
      return <DefaultErrorFallback {...props} />;
    }

    return this.props.children;
  }
}

export default CustomErrorBoundary;
